import { Controller } from "@hotwired/stimulus"

// No jQuery needed - just calls global vendor function with data
export default class extends Controller {
  static values = {
    imageData: Array
  }

  connect() {
    // digitalSectionEventHandlers is defined in app/frontend/vendor/digital-section.js
    // It sets up elimination circles, highlighting, and other digital test features
    // (It uses jQuery internally, but we don't need it here)
    if (typeof digitalSectionEventHandlers === 'function') {
      digitalSectionEventHandlers(this.imageDataValue)
    }
  }
}
